import React from 'react';
import { Button, Image, SelectorList, Text } from '@wix/design-system';
import xor from 'lodash/xor';
import { useModalystInstall } from '../hooks';
import s from './ProductsWidget.module.scss';
const referral = 'wix-aichat';
const action = 'add_dropshipping_products';
const wixOrigin = 'https://bo.wix.com';
const addProductsUrl = `${wixOrigin}/_serverless/dropshipping-assistant/add-products`;
function adaptProductToSelector(product) {
  return {
    id: product.id,
    title: product.title,
    subtitle: product.description,
    image: /*#__PURE__*/React.createElement(Image, {
      src: product.image
    }),
    subtitleNode: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, "Cost from $", product.price),
    selected: false
  };
}
export const DropshippingProductsWidget = _ref => {
  let {
    data: {
      products,
      imageSize
    },
    context: {
      httpClient,
      send,
      onWidgetAction
    }
  } = _ref;
  const [selected, setSelected] = React.useState([]);
  const {
    startInstall
  } = useModalystInstall({
    referral
  });
  const handleSelect = _ref2 => {
    let {
      id
    } = _ref2;
    return setSelected(prev => xor(prev, [id]));
  };
  const handleAddProducts = async () => {
    const value = selected.join(',');
    onWidgetAction(DROPSHIPPING_PRODUCTS_WIDGET, {
      action,
      value
    });
    try {
      const response = await (httpClient == null ? void 0 : httpClient.post(addProductsUrl, {
        selected
      }));
      const {
        metaSiteId,
        token: modalystToken
      } = response == null ? void 0 : response.data;
      send('Add the products I selected to my store');
      startInstall({
        metaSiteId,
        modalystToken
      });
    } catch (error) {
      console.error('Failed to add products', error);
      send('Failed to add products');
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: s.Container
  }, /*#__PURE__*/React.createElement("div", {
    className: s.SelectorListContainer
  }, /*#__PURE__*/React.createElement(SelectorList, {
    maxHeight: "300px",
    multiple: true,
    withSearch: false,
    size: "small",
    imageShape: "rectangular",
    imageSize: imageSize ?? 'large',
    dataSource: () => Promise.resolve({
      items: products.map(adaptProductToSelector),
      totalCount: products.length
    }),
    onSelect: handleSelect
  })), selected.length ? /*#__PURE__*/React.createElement(Button, {
    priority: "secondary",
    size: "small",
    fullWidth: true,
    onClick: handleAddProducts
  }, "Add ", selected.length, " products to my store") : /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, "Select products to add to your store"));
};
export const DROPSHIPPING_PRODUCTS_WIDGET = 'DROPSHIPPING_PRODUCTS_WIDGET';

/** type ToolExecuteResponse.WidgetSpec (Assistant tool that respond with widget) example:
 *
 * widget: {
    widget: 'DROPSHIPPING_PRODUCTS_WIDGET',
    data: {
      products: [
        {
          id: '1',
          title: 'Product 1',
          description: 'Description of product 1',
          image: 'https://via.placeholder.com/150',
          price: '10.00',
        },
      ],
      imageSize: 'large',
    }
  }
*/
//# sourceMappingURL=ProductsWidget.js.map